var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphonePortrait(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 103,
    viewBox: "0 0 152 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.991 99.8943L120.413 84.0273V65.5158C120.413 58.4638 107.015 50.9217 101.902 47.0043",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.707 70.0785L95.8443 59.7685C94.9825 58.9067 93.8136 58.4226 92.5951 58.4226C91.3765 58.4226 90.2076 58.9067 89.3458 59.7685C88.4841 60.6302 88 61.7991 88 63.0177C88 63.621 88.1189 64.2187 88.3497 64.7761C88.5807 65.3336 88.9192 65.8403 89.3458 66.2669L101.807 80.3251V89.1401C101.807 93.3043 107.755 99.8768 107.755 99.8768",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.888 80.4373C101.424 83.1092 100.04 85.5313 97.9784 87.28C95.9167 89.0282 93.3092 89.9912 90.6125 90H60.7751C58.0784 89.9912 55.4709 89.0282 53.4092 87.28C51.3475 85.5313 49.9638 83.1092 49.5 80.4373V14.5714C49.5 11.2373 50.7046 8.03969 53.0488 5.68209C55.393 3.32448 58.5726 2 61.8876 2H89.4999C92.815 2 95.9946 3.32448 98.3388 5.68209C100.683 8.03969 101.888 11.2373 101.888 14.5714V64.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93 57.6923L93 17C93 14.7909 91.2091 13 89 13L63 13C60.7909 13 59 14.7909 59 17L59 75C59 77.2091 60.7909 79 63 79L89 79C91.2091 79 93 77.2091 93 75L93 71.8923",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphonePortrait);
export default __webpack_public_path__ + "static/media/smartphone-portrait.3495ebeaa0078f6e83685d405140b271.svg";
export { ForwardRef as ReactComponent };